import React from 'react';

const ItineraryChangeStepShared = () => (
  <ol>
    <li>
    Cruise Itinerary with ports of call, dates, and total trip cost listed.
    </li>
    <li>
    Proof of payment for your cruise (we accept credit card, bank statements, cancelled checks front/back).
    </li>
    <li>
    Notice from the cruise line which describes the changes to your cruise itinerary (the notice must be dated).
    </li>
    <li>
    Proof of your participation in the cruise (Sign and Sail statement or the final cruise folio/invoice).
    </li>
  </ol>
);

export default ItineraryChangeStepShared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.ItineraryChange/components/ItineraryChangeStepShared.js